import FunctionsRoundedIcon from "@mui/icons-material/FunctionsRounded";
import { Box, Button, ListItemButton, ListItemIcon, Stack, Typography } from "@mui/material";
import type { FormulaFunctionDefinition } from "./utilities/customFormulaFunctions";

interface Props {
  functions: FormulaFunctionDefinition[];
  onFunctionSelect: (fn: FormulaFunctionDefinition) => void;
}

const CustomFormulaFunctionsPanel = ({ functions, onFunctionSelect }: Props) => {
  return (
    <Stack spacing={1.5} sx={{ flex: 1, minHeight: 0 }}>
      <Stack spacing={0.5}>
        <Typography variant="subtitle1">Functions</Typography>
        <Typography variant="caption" color="textSecondary">
          Use built-in functions in your formula
        </Typography>
      </Stack>
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
        <Stack spacing={0.5}>
          {functions.map((fn) => (
            <ListItemButton
              key={fn.name}
              onClick={() => onFunctionSelect(fn)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                borderRadius: "4px",
                py: 0.75,
                px: 1,
                minHeight: "2rem",
              }}
            >
              <ListItemIcon
                sx={(theme) => ({
                  minWidth: "20px",
                  justifyContent: "center",
                  color: theme.palette.info.main,
                })}
              >
                <FunctionsRoundedIcon fontSize="small" />
              </ListItemIcon>
              <Stack sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {fn.name}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {fn.syntax}
                </Typography>
              </Stack>
              <Button
                variant="text"
                size="small"
                color="secondary"
                sx={{ ml: "auto", minWidth: 0, p: 0, fontSize: "12px", "&:hover": { backgroundColor: "transparent" } }}
              >
                Add
              </Button>
            </ListItemButton>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
};

export default CustomFormulaFunctionsPanel;
